import React, { useState } from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button, Input, Label, FormGroup } from 'reactstrap';

const NewLeagueWeekModal = ({ isOpen, toggle, onSave, leagueId }) => {
  const [newWeek, setNewWeek] = useState({
    league: leagueId,
    week: '',
    par: '',
    notes: ''
  });

  const handleSave = () => {
    onSave({
      ...newWeek,
      par: newWeek.par === '' ? null : Number(newWeek.par),
    });
    setNewWeek({ league: leagueId, week: '', par: '', notes: '' });
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setNewWeek(prev => ({ ...prev, [name]: value }));
  };

  return (
    <Modal isOpen={isOpen} toggle={toggle}>
      <ModalHeader toggle={toggle}>Add New Week</ModalHeader>
      <ModalBody>
        <FormGroup>
          <Label for="week">Week Number *</Label>
          <Input
            type="number"
            id="week"
            name="week"
            value={newWeek.week}
            onChange={handleChange}
            placeholder="e.g., 1"
            required
          />
        </FormGroup>
        <FormGroup>
          <Label for="par">Par</Label>
          <Input
            type="number"
            id="par"
            name="par"
            value={newWeek.par}
            onChange={handleChange}
            placeholder="Optional par value"
            min="0"
          />
        </FormGroup>
        <FormGroup>
          <Label for="notes">Notes</Label>
          <Input
            type="textarea"
            id="notes"
            name="notes"
            value={newWeek.notes}
            onChange={handleChange}
            placeholder="Optional notes for this week"
            rows="3"
          />
        </FormGroup>
      </ModalBody>
      <ModalFooter>
        <Button color="primary" onClick={handleSave} disabled={!newWeek.week}>
          Add Week
        </Button>{' '}
        <Button color="secondary" onClick={toggle}>
          Cancel
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default NewLeagueWeekModal;
